<script>
  import { Router, Link, Route } from "svelte-routing"
  import Home from "./pages/Home.svelte"
  import Quote from "./pages/Quote.svelte"
	import Plans from "./pages/Plans.svelte"
  import Plan from "./pages/Plan/Plan.svelte"
  import Thanks from "./pages/Thanks.svelte"
  let url = ""
</script>

<div class="main">
  <Router {url}>
    <nav class="p12">
      <Link to="/">Home</Link>
    </nav>
    <div>
			<Route path="plans" component={Plans} />
			<Route path="plans/:id" component={Plan} />
      <Route path="quote" component={Quote} />
			<Route path="thanks" component={Thanks} />
      <Route path="/" component={Home}/>
    </div>
  </Router>
</div>

<style>
  .main {
    text-align: center;
  }
</style>
